export const isQueryParamUndefined = (param: string | string[] | null): boolean => {
  return !param || param === typeof undefined || param === typeof null;
};
